export default "/images/vendor/flag-icons/flags/4x3/sd.svg?3050433e2767fb821c5d6f787ce65388";